var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.184c1.105 0 2 .743 2 1.658m-2-1.658c-1.105 0-2 .743-2 1.658 0 .916.895 1.658 2 1.658s2 .742 2 1.658c0 .915-.895 1.658-2 1.658m0-6.632V9m0 7.816c-1.105 0-2-.742-2-1.658m2 1.658V18",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5v2.5A2.5 2.5 0 019.5 10H7m5-5h7a2 2 0 012 2v12a2 2 0 01-2 2H9a2 2 0 01-2-2v-9m5-5l-2 2-3 3",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5v0a2 2 0 00-2-2H6a2 2 0 00-2 2v9a2 2 0 002 2h1",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
export default SvgFinancial;